import React from "react";

import s from "./MarketHeader.module.scss";
import WeaveTopBar from "../../../../components/WeaveTopBar/WeaveTopBar";
import PathHelper from "../../PathHelper";

import MarketAvatarWidget from "../MarketAvatarWidget/MarketAvatarWidget";

export default function MarketHeader({
	user,
	hideDatasource,
	onFileLoadComplete,
	goBack,
}) {
	return (
		<div className={s.root}>
			<WeaveTopBar
				className={s.topBar}
				root={PathHelper.getPath("market")}
				onFileLoadComplete={onFileLoadComplete}
				hasAvatar
				hideDatasource={hideDatasource}
				goBack={goBack}
			>
				<MarketAvatarWidget user={user} />
			</WeaveTopBar>
		</div>
	);
}
